
import { oz } from '@weft/utils';
import { OverageSettingsSchema } from '../../primitives';
import { CURRENCIES } from '../../primitives/currency-schema/currency-schema';
import { PAYMENT_PROVIDERS } from '../../primitives/payment-provider-schema';

export const CustomerSettingsSchema = oz.object({
  currency: oz.nativeEnum(CURRENCIES).optional(),
  taxRate: oz.number().optional().nullable(),
  paymentProvider: oz.nativeEnum(PAYMENT_PROVIDERS).optional(),
  paymentProviderMetadata: oz.object({
    providerExternalId: oz.string().optional(),
  }).optional(),
  paymentDueDays: oz.number().optional(),
  overage: OverageSettingsSchema.optional(),
  threshold: oz.number().optional(),
  wallet: oz.string().optional(),
}).openapi('CustomerSettings');

export type CustomerSettings = oz.infer<typeof CustomerSettingsSchema>;